import React from 'react';
import { UserShape } from '../../shapes';
import MobileAppChecker from '../../services/utils/mobile_app_checker';
import LoggedOutMobileApp from './logged_out_mobile_app';
import LoggedOutWeb from './logged_out_web';
import LoggedIn from './logged_in';

export default class Index extends React.Component {
  static propTypes = {
    user: UserShape
  }

  render() {
    if (!this.props.user.get('loggedIn') && !this.props.user.get('loading')) {
      if (MobileAppChecker.isMobileApp()) {
        return(<LoggedOutMobileApp />);
      } else {
        return(<LoggedOutWeb />);
      }
    } else {
      return (<LoggedIn />);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/home/index.jsx